import { _ as __assign } from '../../chunks/bundle-BXYHgzRj.js';
import React__default from 'react';
import { M as MessageInputWrapperView } from '../../chunks/bundle-OSl93HLe.js';
import { useChannelContext } from '../context.js';
import '../../chunks/bundle-Bsdfe5yG.js';
import '../../chunks/bundle-Cytf5OXn.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-DWyboFhb.js';
import '../../chunks/bundle-CqMQE3-R.js';
import '../../GroupChannel/components/SuggestedMentionList.js';
import '../../chunks/bundle-CwopwRQp.js';
import '../../chunks/bundle-DNnUvjnZ.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-u-vzK-oc.js';
import '../../chunks/bundle-DGC3rWK4.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Dwpc_MJZ.js';
import '../../chunks/bundle-ClfkSu0m.js';
import '../../chunks/bundle-DyTMSX7q.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/QuoteMessageInput.js';
import '../../chunks/bundle-CGbKAqtd.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CXA05pe2.js';
import '../../chunks/bundle-DokyceKk.js';
import '../../chunks/bundle-Dz4_R08c.js';
import '../../chunks/bundle-DCjrv9Kz.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-C4eUm39A.js';
import '../../chunks/bundle-Bd7J49Pj.js';
import 'react-dom';
import '../../chunks/bundle-DtujCCHB.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-CZybJwCN.js';
import '../../ui/SortByRow.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-rR4UDSt3.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DmX77DTu.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-CWUQ80OI.js';
import 'dompurify';
import '../../chunks/bundle-BnRVAspH.js';
import '../../chunks/bundle-ySMjorsI.js';
import '../../chunks/bundle-DxT0jQsV.js';
import '../../chunks/bundle-DsnagByW.js';
import '../../chunks/bundle-CdmtMf8Y.js';
import '../../chunks/bundle-CfyvTsrV.js';
import '../../chunks/bundle-Bf00X-bc.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-BKmrhRhi.js';
import '../../chunks/bundle-Bytw3a1z.js';
import '../../chunks/bundle-BqOj5e7u.js';
import '../../chunks/bundle-wIpBG4h1.js';
import '../../chunks/bundle-CXcQbCC8.js';
import '../../chunks/bundle-mZUrgg4o.js';
import '../../chunks/bundle-CeFR-WNJ.js';
import '../../chunks/bundle-CK28kSQl.js';
import '../../chunks/bundle-3OW5t08v.js';
import '../../chunks/bundle-CFXlbz6X.js';
import '../../chunks/bundle-DPABwR4A.js';

var MessageInputWrapper = function (props) {
    var context = useChannelContext();
    var quoteMessage = context.quoteMessage, currentGroupChannel = context.currentGroupChannel, sendMessage = context.sendMessage, sendFileMessage = context.sendFileMessage, sendVoiceMessage = context.sendVoiceMessage, sendMultipleFilesMessage = context.sendMultipleFilesMessage;
    return (React__default.createElement(MessageInputWrapperView, __assign({}, props, context, { currentChannel: currentGroupChannel, messages: context.allMessages, sendUserMessage: function (params) {
            return sendMessage({
                message: params.message,
                mentionTemplate: params.mentionedMessageTemplate,
                mentionedUsers: params.mentionedUsers,
                quoteMessage: quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined,
            });
        }, sendFileMessage: function (params) {
            return sendFileMessage(params.file, quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined);
        }, sendVoiceMessage: function (_a, duration) {
            var file = _a.file;
            return sendVoiceMessage(file, duration, quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined);
        }, sendMultipleFilesMessage: function (_a) {
            var fileInfoList = _a.fileInfoList;
            return sendMultipleFilesMessage(fileInfoList.map(function (fileInfo) { return fileInfo.file; }), quoteMessage !== null && quoteMessage !== void 0 ? quoteMessage : undefined);
        } })));
};

export { MessageInputWrapper, MessageInputWrapper as default };
//# sourceMappingURL=MessageInput.js.map
